import { z } from 'zod';
export const mitigationPsychrometricsCapability = 'mitigation.psychrometrics.v1';
export const mitigationPsychrometricsInputSchema = z.strictObject({
    temperatureFahrenheitMillis: z.number().int().min(-100_000).max(250_000),
    relativeHumidityMillis: z.number().int().min(100).max(100_000),
    atmosphericPressurePascals: z.number().int().min(50_000).max(120_000),
    targetGppMillis: z.number().int().min(0).max(500_000),
    lightMaxDifferenceMillis: z.number().int().min(0).max(500_000),
    moderateMaxDifferenceMillis: z.number().int().min(0).max(500_000),
}).superRefine((value, context) => {
    if (value.moderateMaxDifferenceMillis < value.lightMaxDifferenceMillis) {
        context.addIssue({
            code: 'custom',
            path: ['moderateMaxDifferenceMillis'],
            message: 'The moderate threshold must be at least the light threshold.',
        });
    }
});
export const mitigationPsychrometricsRecommendationBandSchema = z.enum([
    'at-or-below-target',
    'light',
    'moderate',
    'heavy',
]);
export const mitigationPsychrometricsResultSchema = z.strictObject({
    contractVersion: z.literal(mitigationPsychrometricsCapability),
    input: mitigationPsychrometricsInputSchema,
    temperatureCelsiusMillis: z.number().int(),
    saturationVaporPressurePascals: z.number().int().nonnegative(),
    actualVaporPressurePascals: z.number().int().nonnegative(),
    dewPointFahrenheitMillis: z.number().int(),
    mixingRatioGramsPerKilogramMillis: z.number().int().nonnegative(),
    grainsPerPoundMillis: z.number().int().nonnegative(),
    specificHumidityGramsPerKilogramMillis: z.number().int().nonnegative(),
    grainDifferenceMillis: z.number().int(),
    recommendationBand: mitigationPsychrometricsRecommendationBandSchema,
    method: z.literal('magnus-standard-atmosphere-configurable-target-v1'),
});
//# sourceMappingURL=mitigation-psychrometrics.contract.js.map